import { adminClient as apolloClient } from '@/store/apollo';

import ShippingMethodsPaginatedGql from '@/extensions/shop/store/graphql/queries/ShippingMethodsPaginated.gql'
import ShippingMethodsGql from '@/extensions/shop/store/graphql/queries/ShippingMethods.gql'
import ShippingMethodGql from '@/extensions/shop/store/graphql/queries/ShippingMethod.gql'

import CreateShippingMethodGql from '@/extensions/shop/store/graphql/mutations/CreateShippingMethod.gql';
import UpdateShippingMethodGql from '@/extensions/shop/store/graphql/mutations/UpdateShippingMethod.gql';
import DeleteShippingMethodGql from '@/extensions/shop/store/graphql/mutations/DeleteShippingMethod.gql';

export default {
    fetchList: (shopID = null, cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopID) variables.shop = parseInt(shopID);
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: ShippingMethodsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_ShippingMethods))
                .catch(err => reject(err));
        }),
    fetchShippingMethodsPaginated: (data, shopID, cmsID) => new Promise((resolve, reject) => {
        let filters = []
        _.each(data.filters, entry => filters.push(entry))

        apolloClient.query({
            query: ShippingMethodsPaginatedGql,
            variables: {
                currentPage: _.get(data, 'pageInfo.currentPage', 1),
                perPage: _.get(data, 'pageInfo.perPage', 25),
                order: _.get(data, 'variables.order', 'id'),
                direction: _.get(data, 'variables.direction', 'asc'),
                shop: parseInt(shopID),
                cms: cmsID ? parseInt(cmsID) : null,
                filters
            }
        })
            .then(({ data }) => resolve(data.CO_ShippingMethodsPaginated))
            .catch(err => reject(err))
    }),
    fetchShippingMethod: (id) => new Promise((resolve, reject) => {
        apolloClient.query({
            query: ShippingMethodGql,
            variables: {
                id: parseInt(id)
            }
        })
            .then(({ data }) => resolve(data.CO_ShippingMethod))
            .catch(err => reject(err))
    }),
    create: shippingMethod => {
        if (shippingMethod === undefined) throw new Error('required argument is missing')

        shippingMethod = _.removeDeepByKey(shippingMethod, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreateShippingMethodGql,
                variables: { shippingMethod }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_CreateShippingMethod)
                })
                .catch(err => reject(err))
        })
    },
    update: shippingMethod => {
        if (shippingMethod === undefined) throw new Error('required argument is missing')

        shippingMethod = _.removeDeepByKey(shippingMethod, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UpdateShippingMethodGql,
                variables: { shippingMethod }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_UpdateShippingMethod)
                })
                .catch(err => reject(err))
        })
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing')

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: DeleteShippingMethodGql,
                variables: { id }
            })
                .then(async ({ data }) => {
                    await apolloClient.clearStore()
                    resolve(data.CO_DeleteShippingMethod)
                })
                .catch(err => reject(err))
        })
    },
};
